module.exports = __webpack_public_path__ + "static/media/module5.027270d9.png";